<template>
    <div class="card">
        <span class="date">{{ this.months[this.date.getMonth()] + " " + this.date.getDate() + ", " + this.date.getFullYear() }}</span>
        <span class="title">{{ this.title }}</span>
        <div v-html="article" class="article"></div>
        <div>
            <div class="tags" v-for="tag in tags" :key="tag" @click="tagClicked(tag)">{{ "#"+tag }}</div>
        </div>
    </div>
</template>

<style>
    blockquote {
        margin-inline-start: 40px;
        margin-inline-end: 40px;
        margin-block-start: 1em;
        margin-block-end: 1em;
    }

    img{
        max-width: 100%;
        max-height: 100%;
    }

    figcaption{
        width:100%;
        text-align: center;
        font-style: italic;
        padding-bottom: 20px;
    }

</style>

<style scoped>
    div .card{
        padding:20px;
        margin-bottom:20px;

        display:flex;
        flex-direction: column;
    }



    div .card .date{
        text-transform: uppercase;
        font-size:9pt;
    }
    div .card .title{
        margin-bottom:10px;
        font-size:18pt;
        line-height: 110%;
    }

    div .tags{
        font-size:9.5pt;
        text-transform: uppercase;
        display: inline-block;
        margin-top:10px;
        margin-right:10px;
        padding: 3px 10px 3px 10px;
        border-radius:15px;
        cursor:pointer;
    }

    @media(prefers-color-scheme: light){
        div .card{
            background-color:white;
            box-shadow:0 2px 5px 1px #CCCCCC;
        }


        div.card:hover{
            box-shadow:0 2px 5px 1px #AAAAAA;
        }

        div.tags{
            background-color:#F4F4F4;
        }

        div.tags:hover{
            background-color:#EEEEEE;
        }
    }

    @media(prefers-color-scheme: dark){
        div .card{
            background-color:#333333;
        }

        div .card .date{
            color:#EEEEEE;
        }

        div .card .title{
            color:#FFFFFF;
        }

        .article{
            color:#DDDDDD;
        }

        div.tags{
            background-color:#555555;
        }

        div.tags:hover{
            background-color:#666666;
        }

    }

</style>

<script>

    export default{
        props: {
            title:{
                type:String,
                required:true
            },
            date:{
                type:Date,
                required:true
            },
            id:{
                type:String,
                required:false
            },
            article:{
                type:String,
                required:true
            },
            tags:{
                type:Array,
                required:false
            }
        },
        data: function(){
            return {
                months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
            }
        },

        methods: {
            tagClicked:function(tag){
                this.$emit("update:searchTags", [tag]);
            }
        },

        components: { }
    }
</script>